import { render, staticRenderFns } from "./DeleteCouponPool.vue?vue&type=template&id=12226c64"
import script from "./DeleteCouponPool.vue?vue&type=script&lang=js"
export * from "./DeleteCouponPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports